import React, { FunctionComponent, useId } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { default as SyfFooter } from 'syf-component-library/ui/patterns/Footer';
import { getFooterContent } from '../../store/contentSlice';

const fillColor = '#34657f';
const StyledFooter = styled(SyfFooter)`
  a:-webkit-any-link {
    text-decoration: none;
    color: inherit;
    font-family: 'Open Sans Regular', sans-serif;
  }
  li {
    color: ${fillColor};
    font-family: 'Open Sans Bold', sans-serif;
  }
  svg {
    fill: ${fillColor};
  }
`;

const Footer: FunctionComponent = () => {
  const { footerMessage, footerLinks }: any = useSelector(getFooterContent);
  const footerId = useId();

  const updatedLinks = footerLinks.map((link: any, index: number) => {
    const updatedText = `\u00A9${new Date().getFullYear()} ${link.text}`;
    return index === 0 ? { ...link, text: updatedText } : link;
  });

  return (
    <StyledFooter
      id={`syfFooter-${footerId}`}
      data-testid="footer-body-and-link"
      className="mx-4 col-span-12 footer-content"
      body={footerMessage}
      linkList={updatedLinks}
    />
  );
};

export default Footer;
